import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { BaseService } from "../services/base.service";

@Injectable({
    providedIn: "root",
})
export class AuthB2cGuard implements CanActivate {
    constructor(
        private baseService: BaseService,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        return this.baseService.isLoggedB2C$.pipe(
            take(1),
            map((isLogged) => {
                if (!isLogged) {
                    this.router.navigate(["/home"]);
                    return false;
                }
                return true;
            }),
        );
    }
}
